// @flow
import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getServices, setOrganizationsRefuse, withSubscriptions } from '@finect/front-core/User';
import type { WithSubscriptionsProps } from '@finect/front-core/User';
import { AdvisersCTA } from '../../../../../components/AdvisersCTA/AdvisersCTA';
import { Services } from './components';

type Props = {
  user: Object,
  actions: Object,
  match: Object,
  profileSubscriptions: Array<string>,
  services: Array<Object>
} & WithSubscriptionsProps;

type State = {
  app: Object,
  integrations: Array<Object>
};

const mapStateToProps = state => ({
  user: state.user.user,
  profileSubscriptions: state.user.subscriptions.profiles,
  services: state.user.services
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getServices,
      setOrganizationsRefuse
    },
    dispatch
  )
});

class PanelServices extends React.Component<Props, State> {
  state = {
    app: {},
    integrations: []
  };

  static loadInitialData(store: Object, cookies: string) {
    return store.dispatch(getServices(cookies));
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.getServices();
  }

  handleProfileFollow = (id: string) => {
    const { handleEntityFollow } = this.props;
    const follow = !this.props.profileSubscriptions.includes(id);

    handleEntityFollow('profile', 'subscribe', id, follow);
  };

  handleRefuseOrganization = (idOrganization: string, idService: string) => {
    this.props.actions.setOrganizationsRefuse(idOrganization, idService);
  };

  render() {
    const { profileSubscriptions, services, user } = this.props;
    if (!user) return null;

    return (
      <Fragment>
        {/* Expertos financieros con los que has contactado*/}
        <Services
          services={services}
          onProfileFollow={this.handleProfileFollow}
          profileSubscriptions={profileSubscriptions}
          onRefuseOrganization={this.handleRefuseOrganization}
        />

        <AdvisersCTA height={550} />
      </Fragment>
    );
  }
}

export default withSubscriptions(connect(mapStateToProps, mapDispatchToProps)(PanelServices), ['profiles', 'products']);
